import chatWizIconPath from "../../assets/iconsm.png";
import { Image } from "@mantine/core";

/**
 * Renders the ChatWiz icon component.
 *
 * @return {JSX.Element} The ChatWiz icon component
 */

interface ChatWizIconProps {
  isLoginPage?: boolean;
}

export const ChatWizIcon = ({ isLoginPage }: ChatWizIconProps) => {
  return (
    <div className="chatwiz-icon">
      <div className="img-border">
        <Image
          src={chatWizIconPath}
          alt="ChatWiz"
          className="icon icon-loading"
          style={{
            width: isLoginPage ? "1.3125rem" : "2.625rem",
            alignItems: isLoginPage ? "center" : "unset",
            background: "white",
            borderRadius: "6px",
            padding: "2px",
          }}
        />
      </div>
      <div className="filler"></div>
    </div>
  );
};
